import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-compare-product',
  templateUrl: './compare-product.component.html',
  styleUrls: ['./compare-product.component.scss']
})
export class CompareProductComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
